/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CrispEmailHashDto } from '../models/CrispEmailHashDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CrispService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the Crisp Email hash
     * @returns CrispEmailHashDto The Crisp email hash has been returned
     * @throws ApiError
     */
    public crispControllerGetEmailHashV1(): CancelablePromise<CrispEmailHashDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/crisp',
        });
    }
}
